import { Button as MuiButton, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  button: {
    width: '100%',
    marginTop: '30px',
    height: '56px'
  }
});

export default function Button({
  variant = 'contained',
  color = 'primary',
  size = 'large',
  disabled,
  onClick,
  text,
  type,
  className,
  href,
  target
}) {
  const classes = useStyles();

  return (
    <MuiButton
      type={type}
      variant={variant}
      color={color}
      size={size}
      className={className ? className : classes.button}
      disabled={disabled}
      onClick={onClick}
      href={href}
      target={target}
    >
      {text}
    </MuiButton>
  );
}
